import { CollegeDetailService } from './../../services/college-detail.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { CommonRouteFunctionService } from './../../services/common-routing-service';
import { NotificationService } from './../../services/notification.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
 
declare var $; 
 
@Component({
  selector: 'app-college-detail',
  templateUrl: './college-detail.component.html',
  styleUrls: ['./college-detail.component.scss']
})
export class CollegeDetailComponent implements OnInit, OnChanges {

  @Input() collegeData: any;
  isActive: string;
  inputJson: any;
  detailData = {};
  mensClub = [];
  womensClub = [];
  currentCollegeId;
  currentCollegeData;
  renderComponent = 'atAglance';
  collegeProfile: any;
  missionStatementData = '';
  missionStatementDatatype = '';
  dataLoaded = false;
  role: string;
  collegeIdFromParams;
  currentCollegeIdValue;
  primaryColor;
  secondaryColor;
  abbreviation;
  localData: any;
  studentUserId: number;
  showPin: boolean;
  module: string;
  private _radix = 10;
  
  constructor(
    private _commonAuthService: CommonAuthenticationService,
    private notificationService: NotificationService,
    private commonRouteFunctionService: CommonRouteFunctionService,
    private _commonService: CommonService,
    private _commonDataSharedService: CommonDataSharedService,
    private _collegeDetailService: CollegeDetailService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.isActive = localStorage.getItem('navigation');
    this._commonService.scrollToPosition(0);
    const localStorageData = this._commonAuthService.getLoginData();
    this.localData = localStorageData
    this._collegeDetailService.currentStudentId = this.collegeData && this.collegeData.studentId;
    this.role = localStorageData.role;
    this.module = localStorageData.module;
    this.showPin = JSON.parse(localStorage.getItem('routeArray')).includes('coachStudentDetail') || this.module.toLowerCase().trim() === 'student';
    const CollegeIdlocalStorageData = JSON.parse(localStorage.getItem('collegeIdData'));
    this._collegeDetailService.setCurrentCollegeById(this.collegeData && this.collegeData.collegeid ? this.collegeData.collegeid : CollegeIdlocalStorageData && CollegeIdlocalStorageData.collegeData);
    this.currentCollegeIdValue = this.collegeData && this.collegeData.collegeid ? this.collegeData.collegeid : CollegeIdlocalStorageData && CollegeIdlocalStorageData.collegeData;
    this.getCollegeDataOnSearch(this.collegeData && this.collegeData.collegeid ? this.collegeData.collegeid : CollegeIdlocalStorageData && CollegeIdlocalStorageData.collegeData);
    this.getAtaGlanceData();
    this.getLocationData();
    this.getStudentId();
  }

  renderComponents(value) {
    if (value === 'atAglance') {
      this.renderComponent = 'atAglance';
      this.getAtaGlanceData();
      this.getLocationData();
    }
    if (value.toLowerCase().trim() === 'social') {
      this.renderComponent = 'social';
      this.getSocialCampusSportsData();
      this.getSocialSupportServicesData();
      this.getSocialCampusStatisticsData();
      this.getAtaGlanceData();
      const tabIndex = 0;
      this._commonDataSharedService.solidGaugeData.next(tabIndex);
    }
    if (value.toLowerCase().trim() === 'majors') {
      this.renderComponent = 'Majors & Careers';
    }
    if (value.toLowerCase().trim() === 'academic') {
      this.getAddmissionData();
      this.getTransferData();
      this.renderComponent = 'academic';
    }
    if (value.toLowerCase().trim() === 'financial') {
      this.renderComponent = 'financial';
      this.getCollegeGeneralData();
      this.getSocialCampusStatisticsData();
    }
    this._commonService.scrollToPosition($('.ns-college-detail-header').outerHeight(true));
  }

  onTabSelect(event) {
    this._commonDataSharedService.solidGaugeData.next(event);
  }

  ngOnChanges() {
    this._collegeDetailService.currentStudentId = this.collegeData && this.collegeData.studentId;
    this.getCollegeDataOnSearch(this.collegeData && this.collegeData.collegeid ? this.collegeData.collegeid : parseInt(this.collegeIdFromParams, this._radix));
  }

  getCollegeDataOnSearch(collegeId?: number) {
    this.dataLoaded = true;
    this._collegeDetailService.getCurrentCollegeDetail(collegeId)
      .subscribe(
        (data: any) => {
          this.dataLoaded = false;
          this.currentCollegeData = data;
        },
        () => {
          this.dataLoaded = false;
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  pinColleges() {
    const data = this._commonService.getDataWithoutObservable('recentStudentDetail');
      
    this._collegeDetailService.setCollegePin(this.currentCollegeId, this.studentUserId)
      .subscribe(
        () => {
          this.currentCollegeData.pinned = true;
          this.notificationService.show('success', 'College pinned successfully!');
          this._commonDataSharedService.pinCollege.next();
        });
  }

  unPinColleges() {
    const data = this._commonService.getDataWithoutObservable('recentStudentDetail');
    this._collegeDetailService.removeCollegePin(this.currentCollegeId, this.studentUserId)
      .subscribe(
        () => {
          this.currentCollegeData.pinned = false;
          this.notificationService.show('success', 'College unpinned successfully!');
          this._commonDataSharedService.unpinCollege.next();
        });
  }

  getStudentId() {
    if (this.localData.module === 'student') {
      this.studentUserId = this.localData.userId
    } else if (this.localData.module === 'Parent') {
      this.studentUserId = JSON.parse(localStorage.getItem('parentStudentId'));
    }

  }

  favorCollege(college) {
    (college) ? this.unPinColleges() : this.pinColleges();
  }

  getAtaGlanceData() {
    this.inputJson = {
      collegeId: this.currentCollegeId || this._collegeDetailService.currentCollegeId
    };

    this._collegeDetailService.atAGlance(this.inputJson)
      .subscribe(
        (data: any) => {
          this.primaryColor = data.primarycolor;
          this.secondaryColor = data.secondarycolor;
          this.abbreviation = data.abbreviation;
          this.detailData['collegeDetailAtaGlance'] = data;
          this.collegeProfile = data.collegeProfile;
          this.missionStatementData = data.missionStatement;
          if (this.missionStatementData && this.missionStatementData.startsWith('http')) {
            this.missionStatementDatatype = 'url';
          } else if (this.missionStatementData && this.missionStatementData.startsWith('www')) {
            this.missionStatementDatatype = 'url';
          } else if (this.missionStatementData && this.missionStatementData.startsWith('https')) {
            this.missionStatementDatatype = 'url';
          } else {
            this.missionStatementDatatype = 'content';
          }
          this._commonService.setData(this.detailData);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  getAddmissionData() {
    if (this.currentCollegeId) {
      this.inputJson = {
        collegeId: this.currentCollegeId
      };
    }
    this.dataLoaded = true;
    this._collegeDetailService.admissions(this.inputJson)
      .subscribe(
        (data: any) => {
          this.dataLoaded = false;
          this.detailData['collegeDetailaddmission'] = data;
          this._commonService.setData(this.detailData);
        },
        () => {
          this.dataLoaded = false;
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  getTransferData() {
    if (this.currentCollegeId) {
      this.inputJson = {
        collegeId: this.currentCollegeId
      };
    }

    this._collegeDetailService.transfers(this.inputJson)
      .subscribe(
        (data: any) => {
          this.detailData['collegeDetailTransfer'] = data;
          this._commonService.setData(this.detailData);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  getLocationData() {
    if (this.currentCollegeId) {
      this.inputJson = {
        collegeId: this.currentCollegeId
      };
    }

    this._collegeDetailService.location(this.inputJson)
      .subscribe(
        (data: any) => {
          this.detailData['collegeDetailSocialLocation'] = data;
          this._commonService.setData(this.detailData);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  getSocialCampusSportsData() {
    if (this.currentCollegeId) {
      this.inputJson = {
        collegeId: this.currentCollegeId
      };
    }

    this._collegeDetailService.sports(this.inputJson)
      .subscribe(
        (data: any) => {
          this.detailData['collegeDetailSocialCampusSports'] = data;
          this._commonService.setData(this.detailData);
          this.mensClub = data['mensClub'];
          this.womensClub = data['womensClub'];
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  getSocialSupportServicesData() {
    if (this.currentCollegeId) {
      this.inputJson = {
        collegeId: this.currentCollegeId
      };
    }

    this._collegeDetailService.supportservices(this.inputJson)
      .subscribe(
        (data: any) => {
          this.detailData['collegeDetailSocialSupportServices'] = data;
          this._commonService.setData(this.detailData);

        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  getSocialCampusStatisticsData() {
    if (this.currentCollegeId) {
      this.inputJson = {
        collegeId: this.currentCollegeId
      };
    }

    this._collegeDetailService.statistics(this.inputJson)
      .subscribe(
        (data: any) => {
          this.detailData['collegeDetailSocialCampusStatistics'] = data;
          this._commonService.setData(this.detailData);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  getCollegeGeneralData() {

    if (this.currentCollegeId) {
      this.inputJson = {
        collegeId: this.currentCollegeId
      };
    }

    this._collegeDetailService.general(this.inputJson)
      .subscribe(
        (financialAddListJson: any) => {
          const tempObj = { collegeDetailGeneralData: financialAddListJson };
          this.detailData['collegeDetailGeneralData'] = financialAddListJson;
          this._commonService.setData(tempObj);
        },
        () => {
          this.notificationService.show('error', 'Error while calling service');
        });

    this._collegeDetailService.financialStatistics(this.inputJson)
      .subscribe(
        (statisticsListJson: any) => {
          this.detailData['collegeDetailStatisticsData'] = statisticsListJson;
          this._commonService.setData(this.detailData);
        },
        () => {
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  backButtonRedirect() {
    this.router.navigate([this.isActive]);
    this.commonRouteFunctionService.breadCrumb.next(this.isActive);

  }
}
